import React from 'react';
import style from './style.module.scss';
import { useFetch } from '@/hooks';
import Link from 'next/link';
import { NoImage } from '..';
import notImagePoster from '../../public/not-image.png';
import Image from 'next/image';
export const MainNews = async () => {
  const { data } = await useFetch(process.env.NEXT_PUBLIC_API_URL + '/glavnaya-novost?populate=*');
  const link = data?.link;
  let wordFromUrl = null;
  let idFromUrl = null;
  let resultWordFromUrl = null;
  if (link) {
    const regex = /https:\/\/odkb-soyuz\.org\/([a-zA-Z]+)\/(\d+)/;
    const match = link.match(regex);

    if (match) {
      wordFromUrl = match[1]; // "analitiks"
      idFromUrl = match[2]; // "559"
    }
  }

  switch (wordFromUrl) {
    case 'analitics':
      resultWordFromUrl = 'analitikas';
      break;
    case 'intervyus':
      resultWordFromUrl = 'intervyus';
      break;
    case 'pobeda':
      resultWordFromUrl = 'pobedas';
      break
    case 'favorites':
      resultWordFromUrl = 'izbrannyes';
  }

  const { data: oneNews } = await useFetch(
    process.env.NEXT_PUBLIC_API_URL + `/${resultWordFromUrl}/` + `${idFromUrl}` + '?populate=*',
  );

  return (
    <div className={style.wrapper}>
      <Link href={data.link || ''}>
        {oneNews?.previewPicture?.url ? (
          <Image
            src={
              process.env.NEXT_PUBLIC_APP_UPLOAD_URL +
              (oneNews?.previewPicture?.formats?.large?.url || oneNews?.previewPicture?.url)
            }
            width={700}
            height={462}
            alt="poster"
          />
        ) : (
          <NoImage width={700} height={462} image={notImagePoster} />
        )}
        <h1 className={style.title}> {oneNews?.title}</h1>
      </Link>
    </div>
  );
};
